import React from "react";
import FeedBackForm from "./FeedBackForm";
import { BodySmall, Heading6 } from "../common/GlobalElements/Typography.js";
export default function Average(props) {
  return (
    <>
      <div
        className="tab-pane fade"
        id="poor"
        role="tabpanel"
        aria-labelledby="pills-contact-tab"
      >
        <div className="tab-pane-head">
          <Heading6>
            <span>Thanks </span> for your rating.
          </Heading6>
          <BodySmall>
            Your opinion matters to us. We would love to resolve the issue.
            Please give the CEO more details in order to resolve speedily.
          </BodySmall>
        </div>
        <FeedBackForm rating_type={props.rating_type} />
      </div>
    </>
  );
}
